import { DocumentData } from "../types/DocumentData";

export function hasAvailableFile(document?: DocumentData) {
    if (!document) {
        return false;
    }

    return !!document.value?.url;
}

export const filterSupplements = (
    filter: boolean | undefined,
    document: DocumentData
) => {
    // 4 is element type of Report
    const isSupplement =
        document.value.elementType === 4 &&
        document.value.slot === "final" &&
        document.value.availableForCustomer;

    if (filter) {
        return !isSupplement;
    }

    return isSupplement;
};
